<template>
  <b-card>
    <b-row class="mb-1">
      <b-col>
        <b-badge
          variant="light-warning"
          style="margin-bottom: 0px; padding: 10px; white-space: normal; display: block;"
        >
          As filiais não são exibidas devido ao fato de terem o mesmo relatório de pendencias que a Matriz.
        </b-badge>
      </b-col>
      <b-col cols="auto" class="d-flex justify-content-end align-items-center" style="gap: 1rem;">
        <atualizar-em-lote
        tipo-rotina="Situação Fiscal"
        :tool-tip="abilityUpdate ? 'A atualização busca a Situação fiscal na data atual para todas as empresas selecionadas. Cada atualização consumirá um crédito do saldo em conta.': 'Usuário não possui permissão'"
        titulo-cabecalho="Atualização de Situação fiscal em lote"
        subtitulo-cabecalho="Selecione as empresas que deseja atualizar"
        titulo="Selecione a(s) empresa(s) que deseja atualizar a Situação fiscal"
        subtitulo="As empresas listadas abaixo possuem as configurações de certificado digital e procuração válidas para consulta junto ao e-CAC"
        :api="apiSituacaoFiscal"
        alterar-style="font-size: 11.5px; height: 32px; display: inline-flex; align-items: center;"
        :filtros-rapidos="filtrosRapidos"
        :tem-filtro-rapido="true"
        :quantidade-caracteres="32"
        :disabled="!abilityUpdate"
        @atualizar-grid="atualizarGrid()"
      />
      <envio-email-em-lote
        :empresas-selecionadas="this.$refs.situacaFiscalList ? this.$refs.situacaFiscalList.linhaSelecionada : undefined"
        :empresas-grid="this.$refs.situacaFiscalList ? this.$refs.situacaFiscalList.gridInfo.dados : []"
        title="Enviar Situações Fiscais por e-mail"
        nome-arquivo="Situacao Fiscal"
        alterar-style="font-size: 11.5px; height: 32px; display: inline-flex; align-items: center;"
        :evento="enviarEmailEmLote"
        :evento-verificar-email="verificarEmail"
      />
      <download-em-excel
        tipo-arquivo="situações"
        :filtro="filtroAtual"
        tipo="Situação fiscal"
        :api="apiSituacaoFiscal"
        :desabilitado="empresasSelecionadasGrid.length === 0"
        alterar-style="font-size: 11.5px; height: 32px; display: inline-flex; align-items: center;"
        @baixar-em-excel="baixarEmExcel"
        :get-info-extra="montarDto"
      />
      <download-em-lote
        tipo-arquivo="situações"
        tipo="Situação Fiscal"
        :filtro="filtroAtual.filtroBy"
        :palavras-filtro="[['Regulares', 'Irregulares', 'Motivo']]"
        style="margin-bottom: 0px !important;"
        alterar-style="font-size: 11.5px; height: 32px; display: inline-flex; align-items: center;"
        @baixar-lote="baixarEmLote"
      />
      </b-col>
    </b-row>
    <situacao-fiscal-list
      ref="situacaFiscalList"
      :botoes-opcoes="botoesOption"
      :visualizacao-opcoes="visualizacao"
      :filtros="filtros"
      :filtros-rapidos="filtrosRapidos"
      :tem-limpar-filtros="true"
      @selected-rows-change="empresasSelecionadasGrid = $event"
    >
      <template
        slot="custom"
        slot-scope="{ props} "
      >
        <span
          v-if="props.column.field === 'razaoSocial'"
          @click.stop="abrirClick(props)"
        >
          <span
            v-if="props.row.statusAlterado === true"
            style="font-weight: bold"
          >
            {{ props.formattedRow[props.column.field] }}
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </span>

        <span
          v-if="props.column.field === 'consultadoEm' || props.column.field === 'cadastroFederal'"
        >
          <span
            v-if="props.row.statusAlterado === true"
            style="font-weight: bold"
          >
            {{ props.formattedRow[props.column.field] }}
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </span>

        <b-badge
          v-if="props.column.field === 'situacao' && (props.row[props.column.field] == 'Regular' || props.row[props.column.field] == 'SemProcuracaoComCertificadoValido' || props.row[props.column.field] == 'CaixaPostalNaoHabilitada')"
          variant="light-success"
          class="badge-size-p"
        >
          Regular
        </b-badge>
        <b-badge
          v-else-if="props.column.field === 'situacao' && props.row[props.column.field] == 'Irregular'"
          variant="light-danger"
          class="badge-size-p"
        >
          Irregular
        </b-badge>
        <b-badge
          v-else-if="props.column.field === 'situacao' && props.row[props.column.field] == 'Instabilidade'"
          v-b-tooltip.hover
          :title="getTooltipStatus(props.row.mensagemErro)"
          variant="light-primary"
          class="badge-size-p"
        >
          Instabilidade
        </b-badge>
        <b-badge
          v-else-if="props.column.field === 'situacao'"
          v-b-tooltip.hover
          :title="getTooltipSituacao(props.row[props.column.field])"
          variant="light-warning"
          class="badge-size-p"
        >
          {{ props.row[props.column.field] }}

        </b-badge>
      </template>
      <template
        slot="acoes"
        slot-scope="{ props} "
      >
        <acoes
          :ref="`acoes${props.row.id}`"
          :grid-props="props"
          :api="apiSituacaoFiscal"
          :filtros-rapidos="filtroRapidoLimpor"
          tipo-cnd="situacaoFiscal"
          style="display: flex;"
          @atualizar-grid="atualizarGrid()"
        />
      </template>
    </situacao-fiscal-list>
  </b-card>
</template>

<style lang="scss">
.modal-lg {
  max-width: 1000px !important;
}
.acoes-grid {
  display: flex !important;
}
</style>

<script>

import envioHistoricoApi from '@app/shared/services/envio-historico-api'
import { abilityValidation } from '@/auth/utils'
import colunas from './shared/components/colunas'
import api from './shared/services/api'

export default {
  name: 'CndFederalVisualizacao',
  components: {
    SituacaoFiscalList: () => import('@pilar/components/visualizacao-base/VisualizacaoBase.vue'),
    Acoes: () => import('./shared/components/acoes/Acoes.vue'),
    DownloadEmLote: () => import('@app/download-lote/DownloadEmLote.vue'),
    DownloadEmExcel: () => import('@app/download-excel/DownloadEmExcel.vue'),
    AtualizarEmLote: () => import('../shared/components/atualizacao-em-lote/AtualizacaoEmLote.vue'),
    EnvioEmailEmLote: () => import('@app/shared/components/envio-email-lote/EnvioEmailEmLote.vue'),
  },
  data() {
    return {
      empresasSelecionadasGrid: [],
      abilityUpdate: abilityValidation(1, 3),
      apiSituacaoFiscal: api,
      botoesOption: null,
      linha: null,
      visualizacao: {
        placeholderBusca: 'Buscar por: CNPJ/CPF, Razão social',
        acaoClass: 'col-td-acao-2',
      },
      filtros: [{ colunas: ['CadastroFederalSemMascara', 'CadastroFederal', 'RazaoSocial', 'ConsultadoEm'], valor: null }],
      filtrosRapidos: [
        {
          id: 'Regular',
          colunas: ['Situacao'],
          label: 'Regulares',
          valor: '1',
        },
        {
          id: 'Irregular',
          colunas: ['Situacao'],
          label: 'Irregulares',
          valor: '2',
        },
        {
          id: 'SituacaoComAlteracao',
          colunas: ['SituacaoComAlteracao'],
          label: 'Situação com alteração',
          valor: true,
        },
        {
          id: 'Procuracao',
          colunas: ['Situacao'],
          label: 'Procuração',
          valor: '4,9,10,11',
        },
        {
          id: 'ProcuracaoVencida',
          colunas: ['Situacao'],
          label: 'Procuração vencida',
          valor: '9',
        },
        {
          id: 'ProcuracaoCancelada',
          colunas: ['Situacao'],
          label: 'Procuração cancelada',
          valor: '10',
        },
        {
          id: 'SemProcuracao',
          colunas: ['Situacao'],
          label: 'Sem procuração',
          valor: '11',
        },
        {
          id: 'ProcuracaoLimitada',
          colunas: ['Situacao'],
          label: 'Procuração limitada',
          valor: '6',
        },
        {
          id: 'VerificacaoDuasEtapas',
          colunas: ['Situacao'],
          label: 'Verificação duas etapas',
          valor: '15',
        },
        {
          id: 'BaseIndisponivel',
          colunas: ['Situacao'],
          label: 'Base indisponível',
          valor: '13',
        },
        {
          id: 'CadastroGov',
          colunas: ['Situacao'],
          label: 'Cadastro Gov',
          valor: '5',
        },
        {
          id: 'AutorizacaoEcac',
          colunas: ['Situacao'],
          label: 'Autorização e-CAC',
          valor: '7',
        },
        {
          id: 'Instabilidade',
          colunas: ['Situacao'],
          label: 'Instabilidade',
          valor: '3',
        },
        {
          id: 'CertificadoRevogado',
          colunas: ['Situacao'],
          label: 'Certificado revogado',
          valor: '8',
        },
        {
          id: 'CadastroCPFSocio',
          colunas: ['Situacao'],
          label: 'Cadastro CPF sócio',
          valor: '12',
        },
        {
          id: 'PendenteDeAprovacao',
          colunas: ['Situacao'],
          label: 'Pendente de aprovação',
          valor: '14',
        },
        {
          id: 'SemSituacao',
          colunas: ['Situacao'],
          label: 'Sem situação fiscal',
          valor: '3,4,5,6,7,8,9,10,11,12,13,14,15,16,17',
        },
        {
          id: 'ProblemaNaAutenticacao',
          colunas: ['Situacao'],
          label: 'Problema na autenticação',
          valor: '16',
        },
        {
          id: 'OmissaoEFD',
          colunas: ['Omissao'],
          label: 'Omissão de EFD',
          valor: '1',
        },
        {
          id: 'OmissaoPGDAS',
          colunas: ['Omissao'],
          label: 'Omissão de PGDAS-D',
          valor: '2',
        },
        {
          id: 'OmissaoDIRF',
          colunas: ['Omissao'],
          label: 'Omissão de DIRF',
          valor: '3',
        },
        {
          id: 'OmissaoDCTF',
          colunas: ['Omissao'],
          label: 'Omissão de DCTF',
          valor: '4',
        },
        {
          id: 'OmissaoECF',
          colunas: ['Omissao'],
          label: 'Omissão de ECF',
          valor: '5',
        },
        {
          id: 'OmissaoGFIP',
          colunas: ['Omissao'],
          label: 'Omissão de GFIP',
          valor: '6',
        },
        {
          id: 'OmissaoDASN',
          colunas: ['Omissao'],
          label: 'Omissão de DASN',
          valor: '7',
        },
        {
          id: 'OmissaoDASNSIMEI',
          colunas: ['Omissao'],
          label: 'Omissão de DASN SIMEI',
          valor: '9',
        },
        {
          id: 'OmissaoDEFIS',
          colunas: ['Omissao'],
          label: 'Omissão de DEFIS',
          valor: '8',
        },
        {
          id: 'OmissaoDITR',
          colunas: ['Omissao'],
          label: 'Omissão de DITR',
          valor: '10',
        },
        {
          id: 'OmissaoDCTFWeb',
          colunas: ['Omissao'],
          label: 'Omissão de DCTFWeb',
          valor: '11',
        },
        {
          id: 'PendenciaGFIPxGPS',
          colunas: ['Pendencia'],
          label: 'Divergência GFIP x GPS',
          valor: '1',
        },
        {
          id: 'PendenciaDebitoSief',
          colunas: ['Pendencia'],
          label: 'Débito (Sief)',
          valor: '4',
        },
        {
          id: 'PendenciaDebitoSicob',
          colunas: ['Pendencia'],
          label: 'Débito (Sicob)',
          valor: '6',
        },
        {
          id: 'PendenciaDividasAtivas',
          colunas: ['Pendencia'],
          label: 'Dívidas ativas',
          valor: '3',
        },
        {
          id: 'ProcessoArrolamentoBensSief',
          colunas: ['Pendencia'],
          label: 'Processo de arrolamento de bens (Sief)',
          valor: '9',
        },
        {
          id: 'ProcessoFiscalSief',
          colunas: ['Pendencia'],
          label: 'Processo fiscal (Sief)',
          valor: '8',
        },
        {
          id: 'ParcelamentoParcsnParcmei',
          colunas: ['Pendencia'],
          label: 'Parcelamento (PARCSN/PARCMEI)',
          valor: '5',
        },
        {
          id: 'ParcelamentoSipade',
          colunas: ['Pendencia'],
          label: 'Parcelamento (Sipade)',
          valor: '7',
        },
        {
          id: 'ParcelamentoSiefpar',
          colunas: ['Pendencia'],
          label: 'Parcelamento (Siefpar)',
          valor: '10',
        },
        {
          id: 'IrregularidadeCadastral',
          colunas: ['Pendencia'],
          label: 'Irregularidade cadastral',
          valor: 11,
        },
        {
          id: 'PossuiObservacao',
          colunas: ['PossuiObservacao'],
          label: 'Possui observação',
          valor: true,
        },
      ],
      filtroRapidoLimpor: [],
      filtroAtual: {},
      suporte: false,
    }
  },
  mounted() {
    this.aplicarFiltroQuery()
  },
  updated() {
    this.aplicarFiltroQuery()
  },
  created() {
    this.visualizacao.colunas = colunas
    this.visualizacao.colunas[0].evento = this.editar
    this.visualizacao.evento = this.carregar
    this.visualizacao.allpaged = this.allPaged
    this.filtroLimpo()
    this.getTotalFiltro()
  },
  methods: {
    verificarEmail(ids) {
      return api.verificarEmail(ids)
    },
    enviarEmailEmLote(nomeArquivo, emails) {
      return api.enviarEmLote(nomeArquivo, emails)
    },
    setSuporte(isSuporte) {
      this.suporte = isSuporte
    },
    montarDto() {
      if (this.$refs.situacaFiscalList) {
        const empresas = this.$refs.situacaFiscalList.linhaSelecionada
        this.filtroAtual.empresasSelecionadas = !empresas ? [] : empresas
        return this.filtroAtual
      }
      return undefined
    },
    // eslint-disable-next-line no-unused-vars
    carregar(pagina, tamanhoPagina, filtros) {
      this.filtroAtual = filtros
      return api.getPaginado(pagina, tamanhoPagina, filtros).then(async response => {
        if (response.data && response.data.valores && response.data.valores.length > 0) {
          const ids = response.data.valores.map(i => i.id)
          try {
            const statusResp = await envioHistoricoApi.obterStatus(6, ids) // 6 = ETipoRotina.SituaacaoFiscal
            const statusMap = {}
            if (statusResp.data) {
              statusResp.data.forEach(s => { statusMap[s.idRegistro] = s })
            }
            response.data.valores.forEach(item => {
              const status = statusMap[item.id]
              if (status) {
                this.$set(item, 'whatsappEnviado', status.whatsappEnviado)
                this.$set(item, 'emailEnviado', status.emailEnviado)
              }
            })
          } catch (err) {
            this.$erro(err)
          }
        }
        return response
      })
    },
    allPaged(filtro) {
      return api.getTodasLinhas(filtro)
    },
    abrirClick(props) {
      if (props.row.situacao === 'Irregular') {
        this.$refs[`acoes${props.row.id}`].abrirPendencias(props.row)
      } else if (props.row.situacao === 'Regular') {
        this.$refs[`acoes${props.row.id}`].abrirArquivo(props.row)
      } else if (props.row.situacao === 'SemSituacao') {
        this.$refs[`acoes${props.row.id}`].abrirArquivo(props.row)
      } else if (props.row.situacao === 'Base indisponível') {
        this.$refs[`acoes${props.row.id}`].abrirArquivo(props.row)
      }
    },
    aplicarFiltroQuery() {
      this.$nextTick(() => {
        const params = this.$route.query
        if (params && this.$refs.situacaFiscalList) {
          const filtroRapido = params.filtroRapido
            ? this.filtrosRapidos.find(f => f.id === params.filtroRapido)
            : null
          this.$refs.situacaFiscalList.aplicarFiltro(params.busca, filtroRapido)
        }
      })
    },
    baixarEmLote(evt) {
      const empresas = this.$refs.situacaFiscalList.linhaSelecionada
      this.filtroAtual.empresasSelecionadas = !empresas ? [] : empresas
      api.baixaEmLote(this.filtroAtual, evt)
    },
    getTooltipSituacao(situacao) {
      if (situacao === 'Cadastro Gov') {
        return 'Você precisa criar sua conta no portal gov.br. Conclua seu cadastro no Gov para garantir que todas as rotinas sejam executadas corretamente.'
      }
      if (situacao === 'Autorização e-CAC') {
        return 'Será necessário dar autorização de uso de dados. Faço o acesso ao portal e-CAC. Conclua a autorização para garantir que todas as rotinas sejam executadas corretamente.'
      }
      return ''
    },
    getTooltipStatus(mensagemErro) {
      return mensagemErro === undefined || mensagemErro === '' ? '' : `Erro na requisição: (${mensagemErro}), Por favor, Entre em contado com o suporte`
    },
    atualizarGrid() {
      this.$refs.situacaFiscalList.buscar()
      this.getTotalFiltro()
    },
    getTotalFiltro() {
      // getTotalCorrigido
      api.getTotalFiltroSituacaoFiscal(this.filtrosRapidos)
        .then(payload => {
          this.filtrosRapidos.forEach((element, i) => {
            this.filtroRapidoAtual = this.filtrosRapidos[i].label.split(' -')
            this.filtrosRapidos[i].label = `${this.filtroRapidoAtual[0]} - ${payload.data.find(s => s.nome === element.id).total}`
          })
        })
        .catch(error => {
          this.$erro(error)
        })
    },
    filtroLimpo() {
      this.filtrosRapidos.forEach((element, i) => {
        this.filtroRapidoAtual = this.filtrosRapidos[i].label.split(' -')
        this.filtroRapidoLimpor.push({
          id: this.filtrosRapidos[i].id,
          colunas: this.filtrosRapidos[i].colunas,
          label: this.filtroRapidoAtual[0],
          valor: this.filtrosRapidos[i].valor,
        })
      })
    },
  },
}
</script>
